import { z } from 'zod';

const licensedAppSchema = z.object({
  currentTermsOfUse: z.number(),
  description: z.string().min(1),
  expired: z.boolean(),
  homeUrl: z.string().min(1),
  id: z.number(),
  imageSource: z.string().min(1),
  licensed: z.boolean(),
  name: z.string().min(1),
});

export const licensedAppsSchema = z.array(licensedAppSchema);

export type LicensedApp = z.infer<typeof licensedAppSchema>;
